import React from 'react';
import { Car, Home, Fence, Armchair, Layers, Sparkles, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { services } from '../data/mock';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  Car: Car,
  Home: Home,
  Fence: Fence,
  Armchair: Armchair,
  Layers: Layers,
  Sparkles: Sparkles
};

const ServicesSection = ({ onServiceClick }) => {
  const navigate = useNavigate();

  const handleButtonClick = (service) => {
    if (service.title === "Nettoyage Automobile") {
      navigate('/service-automobile');
    } else if (service.title === "Détailing Intérieur") {
      navigate('/service-interieur');
    } else {
      onServiceClick && onServiceClick(service.title);
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Nos Services</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Une gamme complète de services de nettoyage professionnel pour répondre à tous vos besoins
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            const isAutomobile = service.title === "Nettoyage Automobile";
            const isInterieur = service.title === "Détailing Intérieur";
            return (
              <Card 
                key={service.id} 
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-400 overflow-hidden"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center shadow-lg">
                      <IconComponent className="w-6 h-6 text-gray-900" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-yellow-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-bold text-yellow-600">{service.price}</span>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      onClick={() => handleButtonClick(service)}
                      className="text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50 group-hover:translate-x-1 transition-transform"
                    >
                      {(isAutomobile || isInterieur) ? 'En savoir plus' : 'Demander un devis'}
                      <ArrowRight className="w-4 h-4 ml-1" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
